import { render, staticRenderFns } from "./cameraMenu.vue?vue&type=template&id=4f807a94&scoped=true&"
import script from "./cameraMenu.vue?vue&type=script&lang=js&"
export * from "./cameraMenu.vue?vue&type=script&lang=js&"
import style0 from "./cameraMenu.vue?vue&type=style&index=0&id=4f807a94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f807a94",
  null
  
)

export default component.exports